import { Link } from "react-router-dom";

const related = [
  {
    id: 1,
    label: "Sofa Guide",
    title: "Best Beige Sofas for a Calm Living Room",
    excerpt: "The quiet anchor of any calm room — a guide to choosing the right beige sofa for your pillows to live on.",
    path: "/cozy-corners/best-beige-sofas",
    img: "https://public.readdy.ai/ai/img_res/05d0f8b8f2f23f4ff23d3731afeb3fc7.jpg",
  },
  {
    id: 2,
    label: "Rug Guide",
    title: "Neutral Rugs That Make a Room Look Expensive",
    excerpt: "The right neutral rug grounds the room and ties every element — sofa, pillows, and table — together.",
    path: "/products/neutral-rugs",
    img: "https://readdy.ai/api/search-image?query=neutral%20area%20rug%20warm%20ivory%20living%20room%20natural%20light%20calm%20editorial%20interior%20photography%20soft%20texture&width=800&height=500&seq=tp_rel2&orientation=landscape",
  },
  {
    id: 3,
    label: "Coffee Table Guide",
    title: "Best Light Wood Coffee Tables for a Calm Living Room",
    excerpt: "A warm wood table in front of the sofa anchors the seating area and completes the calm room.",
    path: "/products/wood-coffee-tables",
    img: "https://readdy.ai/api/search-image?query=light%20oak%20coffee%20table%20warm%20grain%20texture%20natural%20light%20calm%20living%20room%20editorial%20interior%20photography%20neutral%20palette&width=800&height=500&seq=tp_rel3&orientation=landscape",
  },
];

export default function TPRelated() {
  return (
    <section className="py-20 px-8 md:px-16 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>Keep Reading</p>
          <h2 className="text-[#2C2825] text-2xl md:text-3xl" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>Related Articles</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {related.map(a => (
            <Link key={a.id} to={a.path} className="group flex flex-col cursor-pointer">
              <div className="relative overflow-hidden rounded-2xl mb-5 aspect-[16/10]">
                <img src={a.img} alt={a.title} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>
              <span className="text-[#B5A898] text-[9px] tracking-[0.35em] uppercase mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>{a.label}</span>
              <h3 className="text-[#2C2825] text-base md:text-lg leading-snug mb-3 group-hover:text-[#6B5E53] transition-colors duration-200" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>{a.title}</h3>
              <p className="text-[#8B8378] text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
